(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('@angular/compiler'), require('@angular/core'), require('@angular/platform-server'), require('path'), require('fs'), require('util'), require('critters')) :
    typeof define === 'function' && define.amd ? define('@nguniversal/common/engine', ['exports', '@angular/compiler', '@angular/core', '@angular/platform-server', 'path', 'fs', 'util', 'critters'], factory) :
    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory((global.nguniversal = global.nguniversal || {}, global.nguniversal.common = global.nguniversal.common || {}, global.nguniversal.common.engine = {}), global.ng.compiler, global.ng.core, global.ng.platformServer, global.path, global.fs, global.util, global.critters));
}(this, (function (exports, compiler, core, platformServer, path, fs, util, Critters) { 'use strict';

    function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

    var Critters__default = /*#__PURE__*/_interopDefaultLegacy(Critters);

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */
    /* global Reflect, Promise */
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b)
                if (Object.prototype.hasOwnProperty.call(b, p))
                    d[p] = b[p]; };
        return extendStatics(d, b);
    };
    function __extends(d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }
    var __assign = function () {
        __assign = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s)
                    if (Object.prototype.hasOwnProperty.call(s, p))
                        t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };
    function __rest(s, e) {
        var t = {};
        for (var p in s)
            if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
                t[p] = s[p];
        if (s != null && typeof Object.getOwnPropertySymbols === "function")
            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
                if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                    t[p[i]] = s[p[i]];
            }
        return t;
    }
    function __decorate(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if (d = decorators[i])
                    r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    }
    function __param(paramIndex, decorator) {
        return function (target, key) { decorator(target, key, paramIndex); };
    }
    function __metadata(metadataKey, metadataValue) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
            return Reflect.metadata(metadataKey, metadataValue);
    }
    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) { try {
                step(generator.next(value));
            }
            catch (e) {
                reject(e);
            } }
            function rejected(value) { try {
                step(generator["throw"](value));
            }
            catch (e) {
                reject(e);
            } }
            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }
    function __generator(thisArg, body) {
        var _ = { label: 0, sent: function () { if (t[0] & 1)
                throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function () { return this; }), g;
        function verb(n) { return function (v) { return step([n, v]); }; }
        function step(op) {
            if (f)
                throw new TypeError("Generator is already executing.");
            while (_)
                try {
                    if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
                        return t;
                    if (y = 0, t)
                        op = [op[0] & 2, t.value];
                    switch (op[0]) {
                        case 0:
                        case 1:
                            t = op;
                            break;
                        case 4:
                            _.label++;
                            return { value: op[1], done: false };
                        case 5:
                            _.label++;
                            y = op[1];
                            op = [0];
                            continue;
                        case 7:
                            op = _.ops.pop();
                            _.trys.pop();
                            continue;
                        default:
                            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                                _ = 0;
                                continue;
                            }
                            if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                                _.label = op[1];
                                break;
                            }
                            if (op[0] === 6 && _.label < t[1]) {
                                _.label = t[1];
                                t = op;
                                break;
                            }
                            if (t && _.label < t[2]) {
                                _.label = t[2];
                                _.ops.push(op);
                                break;
                            }
                            if (t[2])
                                _.ops.pop();
                            _.trys.pop();
                            continue;
                    }
                    op = body.call(thisArg, _);
                }
                catch (e) {
                    op = [6, e];
                    y = 0;
                }
                finally {
                    f = t = 0;
                }
            if (op[0] & 5)
                throw op[1];
            return { value: op[0] ? op[1] : void 0, done: true };
        }
    }
    var __createBinding = Object.create ? (function (o, m, k, k2) {
        if (k2 === undefined)
            k2 = k;
        Object.defineProperty(o, k2, { enumerable: true, get: function () { return m[k]; } });
    }) : (function (o, m, k, k2) {
        if (k2 === undefined)
            k2 = k;
        o[k2] = m[k];
    });
    function __exportStar(m, o) {
        for (var p in m)
            if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p))
                __createBinding(o, m, p);
    }
    function __values(o) {
        var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
        if (m)
            return m.call(o);
        if (o && typeof o.length === "number")
            return {
                next: function () {
                    if (o && i >= o.length)
                        o = void 0;
                    return { value: o && o[i++], done: !o };
                }
            };
        throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
    }
    function __read(o, n) {
        var m = typeof Symbol === "function" && o[Symbol.iterator];
        if (!m)
            return o;
        var i = m.call(o), r, ar = [], e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done)
                ar.push(r.value);
        }
        catch (error) {
            e = { error: error };
        }
        finally {
            try {
                if (r && !r.done && (m = i["return"]))
                    m.call(i);
            }
            finally {
                if (e)
                    throw e.error;
            }
        }
        return ar;
    }
    /** @deprecated */
    function __spread() {
        for (var ar = [], i = 0; i < arguments.length; i++)
            ar = ar.concat(__read(arguments[i]));
        return ar;
    }
    /** @deprecated */
    function __spreadArrays() {
        for (var s = 0, i = 0, il = arguments.length; i < il; i++)
            s += arguments[i].length;
        for (var r = Array(s), k = 0, i = 0; i < il; i++)
            for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
                r[k] = a[j];
        return r;
    }
    function __spreadArray(to, from) {
        for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
            to[j] = from[i];
        return to;
    }
    function __await(v) {
        return this instanceof __await ? (this.v = v, this) : new __await(v);
    }
    function __asyncGenerator(thisArg, _arguments, generator) {
        if (!Symbol.asyncIterator)
            throw new TypeError("Symbol.asyncIterator is not defined.");
        var g = generator.apply(thisArg, _arguments || []), i, q = [];
        return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
        function verb(n) { if (g[n])
            i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
        function resume(n, v) { try {
            step(g[n](v));
        }
        catch (e) {
            settle(q[0][3], e);
        } }
        function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
        function fulfill(value) { resume("next", value); }
        function reject(value) { resume("throw", value); }
        function settle(f, v) { if (f(v), q.shift(), q.length)
            resume(q[0][0], q[0][1]); }
    }
    function __asyncDelegator(o) {
        var i, p;
        return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
        function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
    }
    function __asyncValues(o) {
        if (!Symbol.asyncIterator)
            throw new TypeError("Symbol.asyncIterator is not defined.");
        var m = o[Symbol.asyncIterator], i;
        return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
        function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
        function settle(resolve, reject, d, v) { Promise.resolve(v).then(function (v) { resolve({ value: v, done: d }); }, reject); }
    }
    function __makeTemplateObject(cooked, raw) {
        if (Object.defineProperty) {
            Object.defineProperty(cooked, "raw", { value: raw });
        }
        else {
            cooked.raw = raw;
        }
        return cooked;
    }
    ;
    var __setModuleDefault = Object.create ? (function (o, v) {
        Object.defineProperty(o, "default", { enumerable: true, value: v });
    }) : function (o, v) {
        o["default"] = v;
    };
    function __importStar(mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k in mod)
                if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k))
                    __createBinding(result, mod, k);
        __setModuleDefault(result, mod);
        return result;
    }
    function __importDefault(mod) {
        return (mod && mod.__esModule) ? mod : { default: mod };
    }
    function __classPrivateFieldGet(receiver, privateMap) {
        if (!privateMap.has(receiver)) {
            throw new TypeError("attempted to get private field on non-instance");
        }
        return privateMap.get(receiver);
    }
    function __classPrivateFieldSet(receiver, privateMap, value) {
        if (!privateMap.has(receiver)) {
            throw new TypeError("attempted to set private field on non-instance");
        }
        privateMap.set(receiver, value);
        return value;
    }

    var readFile = util.promisify(fs.readFile);
    var access = util.promisify(fs.access);
    function exists(path) {
        return __awaiter(this, void 0, void 0, function () {
            var _a_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, access(path, fs.constants.F_OK)];
                    case 1:
                        _b.sent();
                        return [2 /*return*/, true];
                    case 2:
                        _a_1 = _b.sent();
                        return [2 /*return*/, false];
                    case 3: return [2 /*return*/];
                }
            });
        });
    }

    /** ResourceLoader implementation for loading files */
    var FileLoader = /** @class */ (function () {
        function FileLoader() {
        }
        FileLoader.prototype.get = function (url) {
            return readFile(url, 'utf-8');
        };
        return FileLoader;
    }());

    var CrittersExtended = /** @class */ (function (_super) {
        __extends(CrittersExtended, _super);
        function CrittersExtended(optionsExtended, resourceCache) {
            var _this = _super.call(this, {
                logger: {
                    warn: function (s) { return _this.warnings.push(s); },
                    error: function (s) { return _this.errors.push(s); },
                    log: function () { },
                    info: function () { },
                },
                path: optionsExtended.outputPath,
                publicPath: optionsExtended.deployUrl,
                compress: !!optionsExtended.minify,
                pruneSource: false,
                reduceInlineStyles: false,
                mergeStylesheets: false,
                preload: 'media',
                noscriptFallback: true,
            }) || this;
            _this.optionsExtended = optionsExtended;
            _this.resourceCache = resourceCache;
            _this.warnings = [];
            _this.errors = [];
            return _this;
        }
        CrittersExtended.prototype.readFile = function (path) {
            return __awaiter(this, void 0, void 0, function () {
                var resourceContent;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            resourceContent = this.resourceCache.get(path);
                            if (!(resourceContent === undefined)) return [3 /*break*/, 2];
                            return [4 /*yield*/, readFile(path, 'utf-8')];
                        case 1:
                            resourceContent = _a.sent();
                            this.resourceCache.set(path, resourceContent);
                            _a.label = 2;
                        case 2: return [2 /*return*/, resourceContent];
                    }
                });
            });
        };
        return CrittersExtended;
    }(Critters__default['default']));
    var InlineCriticalCssProcessor = /** @class */ (function () {
        function InlineCriticalCssProcessor(options) {
            this.options = options;
            this.resourceCache = new Map();
        }
        InlineCriticalCssProcessor.prototype.process = function (html, options) {
            return __awaiter(this, void 0, void 0, function () {
                var critters, content;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            critters = new CrittersExtended(Object.assign(Object.assign({}, this.options), options), this.resourceCache);
                            return [4 /*yield*/, critters.process(html)];
                        case 1:
                            content = _a.sent();
                            return [2 /*return*/, {
                                    content: content,
                                    errors: critters.errors,
                                    warnings: critters.warnings,
                                }];
                    }
                });
            });
        };
        return InlineCriticalCssProcessor;
    }());

    /**
     * A common rendering engine utility. This abstracts the logic
     * for handling the platformServer compiler, the module cache, and
     * the document loader
     */
    var CommonEngine = /** @class */ (function () {
        function CommonEngine(moduleOrFactory, providers) {
            if (providers === void 0) { providers = []; }
            this.moduleOrFactory = moduleOrFactory;
            this.providers = providers;
            this.factoryCacheMap = new Map();
            this.templateCache = new Map();
            this.pageExists = new Map();
            this.inlineCriticalCssProcessor = new InlineCriticalCssProcessor({
                minify: true,
            });
        }
        /**
         * Render an HTML document for a specific URL with specified
         * render options
         */
        CommonEngine.prototype.render = function (opts) {
            var _a;
            return __awaiter(this, void 0, void 0, function () {
                var url, pathname, pagePath, pageExists, extraProviders, doc, moduleOrFactory, factory, html, _b, content, errors, warnings;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            if (!(opts.publicPath && opts.documentFilePath && opts.url !== undefined)) return [3 /*break*/, 3];
                            url = new URL(opts.url);
                            pathname = url.pathname.substring(1);
                            pagePath = path.resolve(opts.publicPath, pathname, 'index.html');
                            if (!(pagePath !== path.resolve(opts.documentFilePath))) return [3 /*break*/, 3];
                            pageExists = this.pageExists.get(pagePath);
                            if (!(pageExists === undefined)) return [3 /*break*/, 2];
                            return [4 /*yield*/, exists(pagePath)];
                        case 1:
                            pageExists = _c.sent();
                            this.pageExists.set(pagePath, pageExists);
                            _c.label = 2;
                        case 2:
                            if (pageExists) {
                                // Serve pre-rendered page.
                                return [2 /*return*/, readFile(pagePath, 'utf-8')];
                            }
                            _c.label = 3;
                        case 3:
                            extraProviders = __spread((opts.providers || []), (this.providers || []));
                            doc = opts.document;
                            if (!(!doc && opts.documentFilePath)) return [3 /*break*/, 5];
                            return [4 /*yield*/, this.getDocument(opts.documentFilePath)];
                        case 4:
                            doc = _c.sent();
                            _c.label = 5;
                        case 5:
                            if (doc) {
                                extraProviders.push({
                                    provide: platformServer.INITIAL_CONFIG,
                                    useValue: {
                                        document: opts.inlineCriticalCss
                                            // Workaround for https://github.com/GoogleChromeLabs/critters/issues/64
                                            ? doc.replace(/ media=\"print\" onload=\"this\.media='all'"><noscript><link .+?><\/noscript>/g, '>')
                                            : doc,
                                        url: opts.url
                                    }
                                });
                            }
                            moduleOrFactory = this.moduleOrFactory || opts.bootstrap;
                            return [4 /*yield*/, this.getFactory(moduleOrFactory)];
                        case 6:
                            factory = _c.sent();
                            return [4 /*yield*/, platformServer.renderModuleFactory(factory, { extraProviders: extraProviders })];
                        case 7:
                            html = _c.sent();
                            if (!opts.inlineCriticalCss) {
                                return [2 /*return*/, html];
                            }
                            return [4 /*yield*/, this.inlineCriticalCssProcessor.process(html, {
                                    outputPath: (_a = opts.publicPath) !== null && _a !== void 0 ? _a : (opts.documentFilePath ? path.dirname(opts.documentFilePath) : undefined),
                                })];
                        case 8:
                            _b = _c.sent(), content = _b.content, errors = _b.errors, warnings = _b.warnings;
                            // tslint:disable-next-line: no-console
                            warnings.forEach(function (m) { return console.warn(m); });
                            // tslint:disable-next-line: no-console
                            errors.forEach(function (m) { return console.error(m); });
                            return [2 /*return*/, content];
                    }
                });
            });
        };
        /** Return the factory for a given engine instance */
        CommonEngine.prototype.getFactory = function (moduleOrFactory) {
            return __awaiter(this, void 0, void 0, function () {
                var moduleFactory, factory;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!(moduleOrFactory instanceof core.NgModuleFactory)) return [3 /*break*/, 1];
                            return [2 /*return*/, moduleOrFactory];
                        case 1:
                            moduleFactory = this.factoryCacheMap.get(moduleOrFactory);
                            // If module factory is cached
                            if (moduleFactory) {
                                return [2 /*return*/, moduleFactory];
                            }
                            return [4 /*yield*/, this.getCompiler().compileModuleAsync(moduleOrFactory)];
                        case 2:
                            factory = _b.sent();
                            this.factoryCacheMap.set(moduleOrFactory, factory);
                            return [2 /*return*/, factory];
                    }
                });
            });
        };
        /** Retrieve the document from the cache or the filesystem */
        CommonEngine.prototype.getDocument = function (filePath) {
            return __awaiter(this, void 0, void 0, function () {
                var doc;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            doc = this.templateCache.get(filePath);
                            if (!!doc) return [3 /*break*/, 2];
                            return [4 /*yield*/, readFile(filePath, 'utf-8')];
                        case 1:
                            doc = _b.sent();
                            this.templateCache.set(filePath, doc);
                            _b.label = 2;
                        case 2: return [2 /*return*/, doc];
                    }
                });
            });
        };
        /** Return an instance of the platformServer compiler */
        CommonEngine.prototype.getCompiler = function () {
            var compilerFactory = platformServer.platformDynamicServer().injector.get(core.CompilerFactory);
            return compilerFactory.createCompiler([
                { providers: [{ provide: compiler.ResourceLoader, useClass: FileLoader, deps: [] }] }
            ]);
        };
        return CommonEngine;
    }());

    /**
     * @license
     * Copyright Google LLC All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */

    /**
     * @license
     * Copyright Google LLC All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */

    /**
     * @license
     * Copyright Google LLC All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */

    /**
     * Generated bundle index. Do not edit.
     */

    exports.ɵCommonEngine = CommonEngine;
    exports.ɵInlineCriticalCssProcessor = InlineCriticalCssProcessor;

    Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=common-engine.umd.js.map
